import {
  CREATE_USER,
  CREATE_USER_SUCCESS,
  CREATE_USER_ERROR,
} from './constants';
import axios from 'axios';

export const createUser = () => async (dispatch, getState) => {
  dispatch({ type: CREATE_USER });

  const state = getState();
  const { apiUrl, apiKey, tenant } = state.Config;

  console.log('Creating user');
  console.log('Tenant id is ', tenant);
  try {
    const response = await axios.post(
      `${apiUrl}/ema/user`,
      {
        tenant: tenant,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiKey}`,
        },
      },
    );
    console.log('Created user ', response.data);
    console.log('Created user id ', response.data._id);

    dispatch({ type: CREATE_USER_SUCCESS, payload: response.data });

    return response.data._id;
  } catch (e) {
    dispatch({ type: CREATE_USER_ERROR, payload: e.message });
    console.log(e.message);
  }
};
